import { api } from '@xtnd/web/shared/api';

import { LedgerType } from '../types';
import { CategoryResponse } from '../types/category';
import { SelectOption } from '@repo/ui';

export class CategoryService {
  private readonly baseResource = '/ar-collections/categories';

  async getCategories(ledgerType: LedgerType | null): Promise<SelectOption[]> {
    if (!ledgerType) return Promise.resolve([]);

    const endpoint = `${this.baseResource}?type=${ledgerType}`;
    const { data: categories } = await api.get<CategoryResponse>(endpoint);

    const ledgerTypeOptions: SelectOption[] = categories.map(category => ({
      value: category.entityId,
      label: category.entityName,
    }));

    return ledgerTypeOptions;
  }
}

export const categoryApi = new CategoryService();
